export default "__VITE_ASSET__DjsTwu2f__"